import { globalApi } from 'modules/App/globalApi'

export const updateWorkoutCache = ({ orgId, workoutId, workoutKey, newVal, dispatch }) => {
  dispatch(
    globalApi.util.updateQueryData('listenWorkout', { orgId, workoutId }, (draftWorkout) => {
      draftWorkout[workoutKey] = newVal
    })
  )
}

export const getUpdateWktMutationState = globalApi.endpoints.updateWorkout?.select('largeview-shared-update-workout')

export const getUpdateExerciseMutationState = globalApi.endpoints.updateWorkoutExercise?.select(
  'largeview-shared-update-exercise'
)

export const getRemoveProgramMutationState = globalApi.endpoints.removeProgram?.select(
  'programtable-shared-remove-program'
)
